<template>
	<section class="qly-container">
		<layout-header v-model="isCollapse" />
		<section class="qly-center">
			<layout-aside :isCollapse="isCollapse" />
			<layout-main :isCollapse="isCollapse" />
		</section>
		<!-- <layout-footer /> -->
	</section>
</template>

<script>
	import LayoutHeader from "./layoutHeader";
	import LayoutAside from "./layoutAside";
	import LayoutMain from "./layoutMain";

	export default {
		components: {
			LayoutHeader,
			LayoutAside,
			LayoutMain,
		},
		data() {
			return {
				isCollapse: false,
			}
		}
	};
</script>

<style lang="scss">
	.qly-container {
		height: 100%;
		background-color: #fff;

		.qly-center {
			height: calc(100% - 60px);
			width: 100%;
			display: flex;
			box-sizing: border-box;
		}
	}
</style>